// AI-CONTEXT: See docs/features/impact-per-euro-methodiek.md
// AI-CONTEXT: See docs/features/msi-rekenregels-monetarisering.md

// Versie van de "Impact per euro"-methodiek waarop de berekening is
// gebaseerd. Hoort bij elk gepubliceerd kengetal (§ 5.3) en wordt meegeschreven
// in vastgelegde snapshots — bij een nieuwe methodiekversie worden eerdere
// kengetallen niet met terugwerkende kracht herrekend.
//
// 1.2: de teller rekent met de toegerekende waarde van de MSI-rekenregels
// (impactclaim, tijdshorizon, drop-off, disconto) in plaats van het bruto
// jaarbedrag.
const METHODIEK_VERSIE = '1.2'

// Eerste versie waarin de teller toegerekend is; alles daarvoor heet 'bruto' (§ 6.2).
const TOEGEREKEND_VANAF = [1, 2]

/**
 * Is een vastgelegd kengetal van vóór de rekenregels, en dus bruto?
 * Ontbrekende of onleesbare versies gelden als bruto.
 * @param {string|undefined|null} versie - Kengetal.MethodiekVersie
 * @returns {boolean}
 */
const isBrutoVersie = (versie) => {
    const delen = String(versie || '').split('.').map(Number)
    if (delen.length < 2 || delen.some((d) => !Number.isInteger(d))) return true
    const [major, minor] = delen
    return major < TOEGEREKEND_VANAF[0] || (major === TOEGEREKEND_VANAF[0] && minor < TOEGEREKEND_VANAF[1])
}

export default METHODIEK_VERSIE
export { isBrutoVersie }
